import type {
  TSelectedTool,
  TToolArgumentEditor,
} from '@intone/shared/types';

export function validateFields(currentTool: TSelectedTool,  editorArgs: TToolArgumentEditor[]) {
  const result: string[] = [];
  if (!currentTool.name) result.push('name');
  else if (!/^[a-zA-Z0-9_-]+$/.test(currentTool.name)) return 'Tool name can only contain letters, numbers, underscores and hyphens';
  if (!currentTool.tool_type_id) result.push('tool type');
  editorArgs.forEach(arg => {
    if (arg.is_required) {
      const val = arg.value;
      const isEmpty = val === '' || val === null || val === undefined;
      if (isEmpty) {
        result.push(arg.name);
      }
    }
  })

  return result.length ? `Fields "${result.join(', ')}" can not be empty` : null;
}